export enum LabelConfigurationOption {
  CORE_NUTRIENTS = "nutrients.core",
  VOLUNTARY_NUTRIENTS = "nutrients.voluntary",
  COMBINED_VOLUNTARY_NUTRIENTS = "nutrients.voluntary.no-divider",
  SUPPLEMENT_NUTRIENTS = "nutrients.supplement",
  CUSTOM_NUTRIENTS = "nutrients.client-provided",
  SUGAR_ALCOHOLS_TOGGLE = "nutrients.sugarAlcohols",
  MONO_POLY_TOGGLE = "nutrients.mono-poly",
  OMEGA_3_6_TOGGLE = "nutrients.omega-3-6",

  DIMENSIONS_WIDTH = "dimensions.width",
  RECIPES_AND_UNIT_ANY_QUANTITY = "recipes.arbitrary",
  RECIPES_AND_UNIT_TWO = "recipes.two",
  VOLUNTARY_NUTRIENT_SIDE_BY_SIDE = "nutrients.display.side-by-side",
  CALORIES_449_TEXT = "calories.449.text",
  SHOW_SUPPLEMENT_PROTEIN_DV = "show.supplement-protein-DV",
  SHOW_CARBS_DV = "show.carbs-DV",
  USE_MCG_UNIT = "use.mcg.unit",

  ENABLE_FSIS_MODE = "enable.FSIS.Mode",
  ENABLE_FSIS_MODE_SIMPLIFIED = "enable.FSIS.Mode.Simplified",
  FOOTNOTE_RIGHT_SIDE = "footnote.right-side",
  HIDE_CANADA_SUPPLEMENT_FOOTNOTE = "hide.canada_supplement_footnote",
  US_SUPPLEMENT_ELECTROLYTE_MODE = "us.supplement.electrolyte.mode",
  HIDE_OTHER_TEXT = "hide.other.text",

  CANNABIS_INCL_THC_IMG = "cannabis.incl.thc-img",

  USE_CONDENSED_FONT = "font.condensed",
  USE_INLINE_FOOTNOTE = "footnote.inline",
  ENABLE_CONDENSED_FORMAT = "format.condensed",
  USE_PAR_FRENCH_SERVING_SIZE = "par.french.serving.size",

  SHOW_SALT_FOOTNOTE = "uk.show.salt-footnote",
  SHOW_RI_COLUMN = "uk.show.ri-column",
  SHOW_PER_SERVING_ANALYSIS = "uk.show.per-serving-analysis",
  APPLY_TRAFFIC_LIGHT_COLOR = "uk.bop.traffic-light-color",
  SHOW_TEXT_INDICATORS = "uk.fop.show-text-indicators",
}